import { Howl } from 'howler';
import { useIntl } from 'react-intl';

import BreatheBubble from '..';
import messages from '../messages';

interface CalmHealthBreatheBubbleProps {
	maxBreaths?: number;
	shouldRenderRemainingBreathCopy?: boolean;
	isMuted?: boolean;
}

export default function CalmHealthBreatheBubble({
	maxBreaths,
	shouldRenderRemainingBreathCopy = true,
	isMuted = false,
}: CalmHealthBreatheBubbleProps): JSX.Element {
	const { formatMessage } = useIntl();

	const bubblePath = '/_n/lottie/bubble-center.json';
	const ringPath = '/_n/lottie/breathe-outer-ring.json';
	const inhaleSoundSource = '/_n/audio/calm-medium-inhale.m4a';
	const exhaleSoundSource = '/_n/audio/calm-medium-exhale.m4a';

	const inhaleSound = new Howl({
		src: [`${inhaleSoundSource}`],
		html5: true,
	});

	const exhaleSound = new Howl({
		src: [`${exhaleSoundSource}`],
		html5: true,
	});

	const breathAction = [
		{
			duration: 4,
			type: 'inhale',
			audio: inhaleSound,
			instruction: formatMessage(messages.breatheIn),
		},
		{
			duration: 6,
			type: 'exhale',
			audio: exhaleSound,
			instruction: formatMessage(messages.breatheOut),
		},
	];

	return (
		<BreatheBubble
			breathAction={breathAction}
			bubblePath={bubblePath}
			maxBreaths={maxBreaths}
			ringPath={ringPath}
			shouldRenderRemainingBreathCopy={shouldRenderRemainingBreathCopy}
			isMuted={isMuted}
		/>
	);
}
